<template>
  <div>
    <!-- <vuex-breadcrumb></vuex-breadcrumb>
    <h1 id="jump-to-header">{{heading || "View Collection"}}</h1> -->
    <b-card bg-variant="light">
      <b-row>
        <b-col md="4">
          <collection-show :id="id" @gotAttrs="assignAttrs"></collection-show>
        </b-col>
        <b-col md="8">
          <b-tabs
            active-nav-item-class="font-weight-bold text-uppercase text-warning"
            active-tab-class="font-weight-bold text-success"
            content-class="mt-3"
            lazy
          >
            <b-tab title="Inventory" active>
              <storage-space-dropdown
                :collection_id="id"
                :filtering="storage_space_filtering"
                @selectedItems="setStorageSpace"
              >
              </storage-space-dropdown>
              <div v-if="storage_space_id">
                <product-items-summary :id="storage_space_id"></product-items-summary>
              </div>
              <!-- <storage-space-select
                :filtering="filtering"
                @selectedItems="setStorageSpace"
                select_table_heading="Select Storage Space"
              >
              </storage-space-select> -->
              <product-item-index
                :filtering="product_item_filtering"
                :per_page_setting="15"
                :ams_template="ams_item_template"
              ></product-item-index>
            </b-tab>
            <b-tab title="Team">
              <work-group-index
                :filtering="filtering"
              ></work-group-index>
              <actor-role-index
                :filtering="filtering"
                :ams_template="ams_actor_role_template"
              ></actor-role-index>
            </b-tab>
            <b-tab title="Images">
              <collection-images-summary :id="id"></collection-images-summary>
              <collection-image-index
                :filtering="filtering"
                :per_page_setting="4"
                :ams_template="ams_image_template"
              ></collection-image-index>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {http_v1} from '@/axios'

// import VuexBreadcrumb from './VuexBreadcrumb.vue'
import CollectionShow from './CollectionShow.vue'
import WorkGroupIndex from './WorkGroupIndex.vue'
import ProductItemIndex from './ProductItemIndex.vue'
import CollectionImageIndex from './CollectionImageIndex.vue'
import ProductItemsSummary from './ProductItemsSummary.vue'
import CollectionImagesSummary from './CollectionImagesSummary.vue'
// import StorageSpaceSelect from './StorageSpaceSelect.vue'
import ActorRoleIndex from './ActorRoleIndex.vue'
import StorageSpaceDropdown from './StorageSpaceDropdown.vue'

export default {
  components: {
    // VuexBreadcrumb,
    CollectionShow,
    WorkGroupIndex,
    ProductItemIndex,
    CollectionImageIndex,
    ProductItemsSummary,
    CollectionImagesSummary,
    // StorageSpaceSelect,
    ActorRoleIndex,
    StorageSpaceDropdown
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      filtering: {
        collection_ids: this.id
      },
      product_item_filtering: {
        storage_space_subtree_ids: this.storage_space_id
      },
      storage_space_filtering: {
        storage_accesses: ['access_enclosed', 'access_open']
      },
      storage_space_id: undefined,
      ams_item_template: {
        type: 'product-items',
        description: undefined,
        attributes: {
          'product-listing-id': undefined,
          'storage-space-id': this.storage_space_id,
          'purchased-price-cents': 0,
          'estimated-min-price-cents': 0,
          'estimated-max-price-cents': 0,
          'authenticated-min-price-cents': 0,
          'authenticated-max-price-cents': 0,
          'asking-price-cents': 0,
          'estimated-quality': 9000,
          'authenticated-quality': 0
        }
      },
      ams_image_template: {
        type: 'collection-images',
        description: undefined,
        attributes: {
          'collection-id': this.id,
        }
      },
      ams_actor_role_template: {
        type: 'actor-roles',
        description: undefined,
        attributes: {
          'work-group-id': undefined,
          'profile-id': undefined
        }
      },
      attrs: {},
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.attrs = Object.assign( {}, attrs)
      this.ams_item_template.description = description + ' ' + this.attrs['name']
      this.ams_image_template.description = this.attrs['name'] + ' ' + description
    },
    callStorageSpaceApi(params) {
      http_v1.get (
        'api/admin/v1/storage_spaces', {
          params
        }
      ).then(response => {
        if(response.status == 200) {
          this.storage_space_id = response.data.data[0].id
        }
        else {
          window.console.log(response.status)
        }
      }).catch(error => {
        this.storage_space_id = ''
        if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
    },
    setStorageSpace(items) {
      this.storage_space_id = items[0].id
      this.product_item_filtering.storage_space_subtree_ids = items[0].id
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
    this.callStorageSpaceApi( {location: this.id} )
  }
}
</script>